function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m54 44v10h-44v-10h14 16z",
  fill: "#e9e9e9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m24 36h16v8h-16z",
  fill: "#f3e64d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m40 22c0 4.42-3.58 8-8 8s-8-3.58-8-8 8-12 8-12 8 7.58 8 12z",
  fill: "#ff5f7f"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#532c00"
}, /*#__PURE__*/React.createElement("path", {
  d: "m33.376 8.549-1.376-1.305-1.376 1.305c-1.44 1.364-8.624 8.428-8.624 13.451 0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.023-7.184-12.087-8.624-13.451zm-1.376 19.451c-3.309 0-6-2.691-6-6 0-2.098 3.167-6.212 6.001-9.175 2.833 2.96 5.999 7.072 5.999 9.175 0 3.309-2.691 6-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42 38h6v-4h-32v4h6v4h-14v14h48v-14h-14zm-16 0h12v4h-12zm26 14h-40v-6h40z"
}));

var SvgBurner = function SvgBurner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burner.58c7b47c.svg";
export { ForwardRef as ReactComponent };